import { canadaForData, canadaWhatsappUrl } from "../../data/canadaTaxData";
import { CheckCircle2, XCircle, ArrowRight } from "lucide-react";

export const CanadaForSection = () => (
  <section className="py-24 px-6 bg-white">
    <div className="max-w-[87.5rem] mx-auto">
      <div className="mb-14">
        <span className="text-[#C8283A] text-xs font-black uppercase tracking-[0.2em] mb-3 block" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaForData.sectionLabel}
        </span>
        <h2 className="text-[#0B1829] font-black leading-tight" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3rem)", letterSpacing: "-0.03em" }}>
          {canadaForData.headline}
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl">
        {/* YES card */}
        <div className="rounded-xl border-2 border-[#D4A843]/30 bg-[#FFFDF5] p-7">
          <div className="flex items-center gap-2 mb-5">
            <CheckCircle2 size={18} className="text-[#D4A843]" />
            <h3 className="text-[#D4A843] font-black text-sm uppercase tracking-wide" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {canadaForData.yesTitle}
            </h3>
          </div>
          <ul className="flex flex-col gap-3">
            {canadaForData.yesItems.map((item, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-[#0B1829]" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                <CheckCircle2 size={14} className="text-[#D4A843] flex-shrink-0 mt-0.5" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* NO card */}
        <div className="rounded-xl border-2 border-[#C8283A]/20 bg-[#FDF1F2] p-7">
          <div className="flex items-center gap-2 mb-5">
            <XCircle size={18} className="text-[#C8283A]" />
            <h3 className="text-[#C8283A] font-black text-sm uppercase tracking-wide" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {canadaForData.noTitle}
            </h3>
          </div>
          <ul className="flex flex-col gap-3 mb-5">
            {canadaForData.noItems.map((item, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-[#5A6A7A]" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                <XCircle size={14} className="text-[#C8283A] flex-shrink-0 mt-0.5" />
                {item}
              </li>
            ))}
          </ul>
          <div className="border-t border-[#C8283A]/10 pt-4">
            <p className="text-[#5A6A7A] text-xs leading-relaxed mb-3" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {canadaForData.noNote}
            </p>
            <a
              href={canadaWhatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-[#C8283A] text-xs font-bold hover:underline"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              Message us on WhatsApp <ArrowRight size={12} />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);
